import { Avatar, Card, Divider, Grid, Typography } from "@mui/material";
import millify from "millify";
import React from "react";
import { Link } from "react-router-dom";

const Top10Cryptos = ({ data, isCountTen, setIsCountTen }) => {
  return (
    <Grid container direction="column" sx={{ mt: "2rem" }}>
      <Typography align="center" sx={{ fontWeight: 500 }} variant="h4">
        Top 10 Cryptos
      </Typography>

      <Grid item sx={{ mt: "2rem" }}>
        <Grid item container spacing={3}>
          {data?.data?.coins?.map((coin) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              key={coin.uuid}
              sx={{ mb: "1rem" }}
            >
           <Link to={`/cryptos/chart/${coin.uuid}`}>
           <Card component="article" sx={{ pl: 2 }}>
                <Grid container direction="column" sx={{ pt: 2 }}>
                  <Grid item>
                    <Grid item container>
                      <Grid item xs={8}>
                        <Typography variant="h6">{`${coin.rank}. ${coin.name}`}</Typography>
                      </Grid>
                      <Grid
                        item
                        container
                        xs={4}
                        justifyContent="flex-end"
                        sx={{ pr: 4 }}
                      >
                        <Avatar src={coin.iconUrl} alt={coin.name} />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Divider sx={{ mt: 2, mb: 2, ml: -2 }} />
                  <Grid item sx={{ mb: "1.5rem" }}>
                    <Grid item container direction="column">
                      <Grid item>Price: {millify(coin.price)}$</Grid>
                      <Grid item>Market Cap: {millify(coin.marketCap)}</Grid>
                      <Grid item>Daily Change: {coin.change}%</Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
           </Link>
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid item container justifyContent="flex-end">
        <Grid item>
          <Typography
            onClick={() => setIsCountTen((prev) => !prev)}
            sx={{ mr: 2, color: "primary.main", cursor: "pointer" }}
            variant="h6"
          >
            Show {isCountTen ? "more" : "10"}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Top10Cryptos;
